'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var MuiDialog = require('@mui/material/Dialog');
var MuiDialogContent = require('@mui/material/DialogContent');
var components_Headline2_index = require('../Headline2/index.js');
var components_SvgIcon_index = require('../SvgIcon/index.js');
var close = require('../../close-684728c7.js');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var MuiDialog__default = /*#__PURE__*/_interopDefaultLegacy(MuiDialog);
var MuiDialogContent__default = /*#__PURE__*/_interopDefaultLegacy(MuiDialogContent);

var StyledModal = styled__default["default"](MuiDialog__default["default"]).attrs({
    BackdropProps: { style: { backgroundColor: 'rgba(34, 34, 45, 0.25)' } },
})(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject([""], [""])));
var StyledDialogContent = styled__default["default"](MuiDialogContent__default["default"])(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  padding: 40px;\n"], ["\n  padding: 40px;\n"])));
var TitleContainer = styled__default["default"].div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var BodyContainer = styled__default["default"].div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  margin-top: 27px;\n"], ["\n  margin-top: 27px;\n"])));
var CloseButton = styled__default["default"].button(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  all: unset;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n"], ["\n  all: unset;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n"])));
var CloseIcon = styled__default["default"](components_SvgIcon_index["default"]).attrs({
    icon: close.SvgClose,
    size: constants_properties.SVG_ICON_SIZES.SMALL,
    stroke: constants_properties.SVG_ICON_COLORS.PRIMARY,
})(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject([""], [""])));
var Title = styled__default["default"](components_Headline2_index["default"])(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  padding-right: 20px;\n"], ["\n  padding-right: 20px;\n"])));
var Modal = function (_a) {
    var open = _a.open, onClose = _a.onClose, title = _a.title, _b = _a.hide_close_button, hide_close_button = _b === void 0 ? false : _b, children = _a.children, className = _a.className;
    return (React__default["default"].createElement(StyledModal, { fullWidth: true, className: className, open: open, onClose: onClose },
        React__default["default"].createElement(StyledDialogContent, null,
            React__default["default"].createElement(TitleContainer, null,
                title && React__default["default"].createElement(Title, null, title),
                !hide_close_button && (React__default["default"].createElement(CloseButton, { onClick: onClose },
                    React__default["default"].createElement(CloseIcon, null)))),
            React__default["default"].createElement(BodyContainer, null, children))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

exports["default"] = Modal;
